import { auth } from "../services/firebase.init";
import { getLoginRedirectPath } from "./login-redirect";

let recovery: Promise<void> | undefined;

export function loginRecovery(): Promise<void> {
  if (!recovery) {
    const destination = getLoginRedirectPath(window.location);
    recovery = auth
      .signOut()
      // Still reach login if ending the expired Firebase session fails.
      .catch(() => {})
      .then(() => {
        window.location.replace(destination);
      });
  }
  return recovery;
}
